// @flow strict

export default Object.freeze({
  neutral: {
    backgroundColor: 'secondary',
  },
  success: {
    icon: 'check-circle',
    iconColor: 'success',
    color: 'successBase',
    backgroundColor: 'successWeak',
  },
  info: {
    icon: 'info-circle',
    iconColor: 'info',
    color: 'infoBase',
    backgroundColor: 'infoWeak',
  },
  warning: {
    icon: 'workflow-status-warning',
    iconColor: 'warning',
    color: 'warningBase',
    backgroundColor: 'warningWeak',
  },
  error: {
    icon: 'workflow-status-problem',
    iconColor: 'error',
    color: 'errorBase',
    backgroundColor: 'errorWeak',
  },
  recommendation: {
    icon: 'sparkle',
    iconColor: 'recommendation',
    color: 'recommendationBase',
    backgroundColor: 'recommendationWeak',
  },
});
